import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { IonicVue } from '@ionic/vue';
import { isPlatform } from '@ionic/vue';
import { App as CapApp, URLOpenListenerEvent } from '@capacitor/app';
import { useAuthStore } from '@/stores/useAuthStore';
import * as Sentry from '@sentry/capacitor';
import * as SentryVue from '@sentry/vue';
//@ts-ignore
import { useLibraryStore } from '@/stores/useLibraryStore';
//@ts-ignore
import FernandPlugin from '@/plugins/FernandPlugin';
import { isLoggedIn, setAuthTokens, getAccessToken } from 'axios-jwt';
import { Preferences } from '@capacitor/preferences';
// import eruda, { Eruda } from 'eruda';
// eruda.init()

// import { Playback } from 'playback';
var decode = function (input: string) {
  // Replace non-url compatible chars with base64 standard chars
  input = input
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .replace('%3D%3D', '==')

  // Pad out with standard base64 required padding characters
  var pad = input.length % 4;
  if (pad) {
    if (pad === 1) {
      throw new Error('InvalidLengthError: Input base64url string is the wrong length to determine padding');
    }
    input += new Array(5 - pad).join('=');
  }
  return input;
}
/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
// import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Main app styles + Tailwind */
import './theme/app.css';

import { Capacitor } from "@capacitor/core";
import { CapacitorSQLite, SQLiteConnection } from "@capacitor-community/sqlite";
import {
  defineCustomElements as jeepSqlite,
} from "jeep-sqlite/loader";
import { Playback } from 'playback';

Playback.echo({ value: 'b' })

jeepSqlite(window);

window.addEventListener("DOMContentLoaded", async () => {

  CapApp.addListener('appUrlOpen', async (event: URLOpenListenerEvent) => {
    // alert(event.url)

    // Check if jwt is in query params
    const queryParams = extractQueryParams(event.url);
    let jwtTokenEncoded = queryParams?.jwt
    if (jwtTokenEncoded) {
      let decoded = decode(jwtTokenEncoded)
      let jwtToken = decoded
      try {
        jwtToken = atob(decoded)
        let data = {
          authorization: {
            token: jwtToken
          }
        }
        await Preferences.set({
          key: 'auth',
          value: JSON.stringify({ data }),
        });
      } catch (e) { }

      setAuthTokens({
        accessToken: jwtToken,
        refreshToken: jwtToken,
      })
    }

    if (event.url.indexOf('applink') !== -1) {
      // alert('applink: ' + event.url.split('/applink')[1])
      return router.push({ path: event.url.split('/applink')[1] });
    }

    const subdomain = event.url.split('://')[1].split('.')[0];
    if (subdomain === process.env.VUE_APP_APP_HOST.split('.')[0]) {
      // alert('library: ' + event.url.split('/#')[1])
      // This is the web version of the app, so use the path directly
      return router.push({ path: event.url.split('/#')[1] });
    }

    const splitter = process.env.VUE_APP_APPSCHEME && event.url.indexOf(process.env.VUE_APP_APPSCHEME) === 0
        ? process.env.VUE_APP_APPSCHEME
        : process.env.VUE_APP_WEB_HOST && process.env.VUE_APP_WEB_HOST + '/' || '';

    if (!splitter) {
        console.error('Invalid splitter: VUE_APP_APPSCHEME and VUE_APP_WEB_HOST are not defined');
        return;
    }

    const parts = event.url ? event.url.split(splitter) : [];
    if (parts.length < 2) {
        console.error('Invalid URL format');
        return;
    }

    const path = parts[1] || '';
    const uriParts = path.split('?');
    const uri = uriParts[0] || '';
    const segments = uri.split('/').filter(segment => segment.length > 0);

    if (segments[0] === 'login' && !isLoggedIn()) {
      return router.push({ name: 'login' });
    } else if (segments[0] === 'register' && !isLoggedIn()) {
      return router.push({ name: 'register' });
    } else if (segments[0] === 'account') {
      return router.push({ name: 'settings' });
    } else if (segments[0] === 'library') {
      return router.push({ name: 'list', params: { list: 'library' } });
    } else if (subdomain && segments[0] === 'listen' && segments.length === 2) {
      // alert('wildcard: ' + subdomain + ' ' + segments[1])
      // This is a promo page with a wildcard subdomain (aka, the team's subdomain)
      return router.push({ name: 'player-page', params: { team: subdomain, promo: segments[1] } });
    } else {
      return router.push({ path: `/${path}` });
    }
  });

  function extractQueryParams(url: string): { [key: string]: string } {
    let queryParams: { [key: string]: string } = {};
    // Extract the part after the question mark
    const queryString = url.split('?')[1];

    if (!queryString) {
      return queryParams;
    }

    // Split the string into individual key=value pairs
    const pairs = queryString.split('&');

    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i].split('=');
      const key = decodeURIComponent(pair[0]);
      const value = decodeURIComponent(pair[1] || '');
      //@ts-ignore
      queryParams[key] = value;
    }

    return queryParams;
  }

  const platform = Capacitor.getPlatform();
  const sqlite = new SQLiteConnection(CapacitorSQLite);

  const pinia = createPinia();

  const app = createApp(App).use(IonicVue, {
    hardwareBackButton: true,
    mode: 'ios'
  })
    .use(router)
    .use(pinia)
    .use(FernandPlugin, {
      appId: process.env.VUE_APP_FERNAND_APP_ID
    });

  // Sentry
  if (process.env.NODE_ENV === 'production') {
    Sentry.init(
      {
        app,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [
          Sentry.browserTracingIntegration(),
        ],
        // Set tracePropagationTargets for trace propagation
        tracePropagationTargets: [process.env.VUE_APP_BASE_URL],
        // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: 0.1,
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,

        // Enable Capacitor-specific options
        enableNative: Capacitor.isNativePlatform(),
        release: `${process.env.VUE_APP_VERSION}`,
      },
      // Forward the init method from @sentry/vue
      SentryVue.init
    );
  }

  let sqliteEnabled = true;
  
  if (platform === "web") {
    try {
      // For web platform, disable SQLite entirely to avoid WASM issues
      console.log('Disabling SQLite for web platform to prevent WASM memory errors');
      sqliteEnabled = false;
    } catch (e) {
      console.error('Error with SQLite setup:', e);
      sqliteEnabled = false;
    }
  }

  // Define table schemas
  const createLibraryApiCache = `
    CREATE TABLE IF NOT EXISTS lib_api_cache (
    url TEXT NOT NULL,
    content TEXT NOT NULL);`;

  const createHistoryApiCache = `
    CREATE TABLE IF NOT EXISTS history_api_cache (
    user_id INTEGER NOT NULL,
    track_id INTEGER NOT NULL,
    content TEXT NOT NULL);`;

  const createPromosApiCache = `
    CREATE TABLE IF NOT EXISTS promos_api_cache (
    promo_url TEXT NOT NULL,
    content TEXT NOT NULL);`;

  const createDownloadedPromosCache = `
  CREATE TABLE IF NOT EXISTS downloaded_promos_cache (
    user_id INTEGER NOT NULL,
    promo_id INTEGER NOT NULL,
    content TEXT NOT NULL);`;

  const createDownloadedFiles = `
  CREATE TABLE IF NOT EXISTS downloaded_files (
    book_id INTEGER NOT NULL,
    track_id INTEGER NOT NULL);`;

  const create_sync_playback_history = `
    CREATE TABLE "sync_playback_history" (
      "track_id"    INTEGER,
      "team_id"    INTEGER,
      "book_id"    INTEGER,
      "playback_rate"    REAL,
      "current_position"    REAL,
      "seconds_played_since_sync"    REAL,
      "dt_last_updated"    INTEGER,
      "promo_id"    INTEGER,
      "team_slug" TEXT,
      "promo_slug" TEXT,
      PRIMARY KEY("track_id")
  );`;

  const create_all_playback_history = `
    CREATE TABLE "all_playback_history" (
      "track_id"    INTEGER,
      "team_id"    INTEGER,
      "book_id"    INTEGER,
      "playback_rate"    REAL,
      "current_position"    REAL,
      "seconds_played_since_sync"    REAL,
      "dt_last_updated"    INTEGER,
      "promo_id"    INTEGER,
      "team_slug" TEXT,
      "promo_slug" TEXT,
      PRIMARY KEY("track_id")
    );`;

  async function initializeDatabase() {
    // Skip SQLite initialization if disabled (e.g., on web platform)
    if (!sqliteEnabled) {
      console.log('SQLite disabled for this platform - skipping database initialization');
      return true;
    }
    
    let db = null;
    try {
      const ret = await sqlite.checkConnectionsConsistency();
      const isConn = (await sqlite.isConnection("db", false)).result;
      
      if (ret.result && isConn) {
        console.log('Retrieving existing connection');
        db = await sqlite.retrieveConnection("db", false);
      } else {
        console.log('Creating new connection');
        db = await sqlite.createConnection(
          "db",
          false,
          "no-encryption",
          1,
          false
        );
      }
      
      if (!db) {
        throw new Error('Failed to create or retrieve database connection');
      }

      console.log('Opening database connection');
      await db.open();
      
      const tables = [
        { name: 'lib_api_cache', sql: createLibraryApiCache },
        { name: 'history_api_cache', sql: createHistoryApiCache },
        { name: 'promos_api_cache', sql: createPromosApiCache },
        { name: 'downloaded_promos_cache', sql: createDownloadedPromosCache },
        { name: 'downloaded_files', sql: createDownloadedFiles },
        { name: 'sync_playback_history', sql: create_sync_playback_history },
        { name: 'all_playback_history', sql: create_all_playback_history }
      ];
      
      for (const table of tables) {
        try {
          console.log(`Creating table: ${table.name}`);
          await db.execute(table.sql);
        } catch (e) {
          console.warn(`Error creating table ${table.name}:`, e);
        }
      }
      
      return true;
    } catch (e) {
      console.error('Database initialization error:', e);
      if (e instanceof Error) {
        console.error('Error details:', e.message);
        console.error('Error stack:', e.stack);
      }
      return false;
    } finally {
      if (db) {
        try {
          console.log('Closing database connection');
          await db.close();
        } catch (closeError) {
          console.error('Error closing database:', closeError);
        }
      }
    }
  }

  // Initialize database before mounting the app
  const dbInitialized = await initializeDatabase();
  if (!dbInitialized && platform === "web") {
    console.warn('Database initialization failed on web platform - this may affect app functionality');
  }

  // Setup Global Helper Functions
  const rootSvg = require.context('./svgs/', true, /\.svg$/);
  const themeSvg = require.context('./svgs/theme/', true, /\.svg$/);

  app.config.globalProperties.$svg = (name: string) => {
    // Prioritize theme
    if (themeSvg.keys().includes(`./${name}.svg`)) {
      return themeSvg(`./${name}.svg`);
    }

    // Fallback to root
    return rootSvg(`./${name}.svg`);
  };

  app.config.globalProperties.$icon = (name: string, lib = 'fontawesome') => {
    // Prioritize theme
    if (themeSvg.keys().includes(`./${name}.svg`)) {
      return themeSvg(`./${name}.svg`);
    }

    // Fallback to root
    const defaultPath = lib ? `./icons/${lib}/${name}.svg` : `./icons/${name}.svg`;
    if (rootSvg.keys().includes(defaultPath)) {
      return rootSvg(defaultPath);
    }

    return rootSvg('./icons/circle-question.svg');
  };

  //@ts-ignore
  window.sqlite = sqlite

  router.isReady().then(() => {
    app.mount('#app');
  });
})
// eslint-disable-next-line
console.log(`v${process.env.VUE_APP_VERSION}`);
